import { lazy } from "react";

const GroupPermission = lazy(() => import("./Group"));

const SlipPermission = lazy(() => import("./Slip"));

const ConfigurationPermission = lazy(() => import("./Configuration"));

const ApprovalConfiguration = lazy(() => import("./Approval"));

const ExportedMaterialConfig = lazy(() => import("./ExportedMaterialConfig"));
const ReportedMaterialConfig = lazy(() => import("./ReportedMaterialConfig"));

export {
  ApprovalConfiguration,
  ConfigurationPermission,
  ExportedMaterialConfig,
  GroupPermission,
  ReportedMaterialConfig,
  SlipPermission,
};
